import { NAVIGATE } from './typeConstants';

export const navigate = (route, params) => ({
    type: NAVIGATE,
    route,
    params
});
